import { render } from "./SearchBar2.vue?vue&type=template&id=a65f170c&scoped=true"
import script from "./SearchBar2.vue?vue&type=script&lang=js"
export * from "./SearchBar2.vue?vue&type=script&lang=js"

import "./SearchBar2.vue?vue&type=style&index=0&id=a65f170c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65f170c"]])

export default __exports__